import type { TimeFormatValue } from '@elfsight/configurator-contracts';

export const determineTimeFormat = (
  format: TimeFormatValue,
  locale: string
) => {
  if (format === '12-hour') {
    return '12hr';
  }

  if (format === '24-hour') {
    return '24hr';
  }

  const options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric'
  };
  const parts = new Intl.DateTimeFormat(locale, options).formatToParts(
    new Date()
  );

  return parts.some((part) => part.type === 'dayPeriod') ? '12hr' : '24hr';
};
